import styles from "./Button.module.css";

type Props = {
  onPress: () => void;
};

export const Button = (props: Props) => {
  return (
    <div className={styles.container} onClick={props.onPress}>
      <div className={styles.arrow} />
      <div className={styles.label}>More</div>
    </div>
  );
};
